<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card class="md-card-plain">
          <md-card-header>
            <h4 class="title">Hayoooo nyari apa, gak ketemu ya? Balik aja deh.... :D</h4>
          </md-card-header>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
